<!-- Header -->
<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon primary small">
      <div class="inner"><i class="ti ti-send"></i></div>
    </div>
    <span class="title ms-2">Mon envoi à {{ destinationTitle }}</span>
  </div>
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>

<!-- Share content -->
<div class="modal-content d-flex flex-row align-items-stretch justify-content-center" [formGroup]="form">
  <div id="create-document" class="d-flex flex-column">
    <ng-container *ngIf="user?.accessType === 'enterprise'">
      <div class="share-column-header d-flex align-items-center justify-content-center">
        <span class="label">Documents de ma bibliothèque</span>
      </div>
      <!-- Library documents -->
      <div class="share-column-content d-flex flex-column gap-3 w-100">
        <div class="d-flex flex-column gap-2 form-group w-100">
          <label class="form-label">Joindre des documents de ma bibliothèque</label>
          <app-select [options]="documents" *ngIf="documents" formControlName="documents" class="m outlined w-100 top"
            [multiple]="true"></app-select>
        </div>
      </div>
    </ng-container>
    <!-- Temporary documents -->
    <div class="share-column-header d-flex align-items-center justify-content-center">
      <span class="label">Fichiers joints</span>
    </div>
    <div class="share-column-content d-flex flex-column gap-3 w-100">
      <p class="info-message mt-2 mb-2">
        <i class="ti ti-info-hexagon"></i>
        Ces fichiers seront joints à l'envoi et n'apparaîtront pas dans la bibliothèque de l'entreprise.
      </p>
      <div class="d-flex flex-column gap-2">
        <div *ngFor="let file of (form.value.files || [])" class="uploaded-file">
          <span>{{ file.name }}</span>
          <button class="button m icon transparent" (click)="removeFile(file)"><i class="ti ti-trash"></i></button>
        </div>
      </div>
      <app-file-uploader (onFilesAdded)="addFile($event)"></app-file-uploader>
    </div>
  </div>
  <!-- Right column : message & destination -->
  <div id="share" class="d-flex flex-column">
    <div class="share-column-header d-flex align-items-center justify-content-center">
      <span class="label">Destinataire</span>
    </div>
    <div class="share-column-content d-flex flex-column gap-3 w-100">
      <!-- Enterprise share : pick a target (insured or mutuelle) -->
      <ng-container *ngIf="user?.accessType === 'enterprise'">
        <div class="info-message mt-2 mb-2">
          <i class="ti ti-info-hexagon"></i>
          Envoyez un message et des documents à une ou plusieurs salariés ou à la mutuelle.
        </div>
        <div class="d-flex flex-column gap-2 form-group w-100" [ngClass]="{disabled: forceTarget}">
          <label class="form-label required">Destinataire</label>
          <app-select [options]="targets" *ngIf="targets" formControlName="target"
            class="m outlined w-100"></app-select>
        </div>
        <!-- Select insureds -->
        <ng-container *ngIf="selectedTarget === 'insured'">
          <div class="d-flex flex-column gap-2 form-group w-100 mt-3">
            <label class="checkbox">
              <input class="me-2" type="checkbox" formControlName="allInsureds" (change)="onAllInsuredsChecked($event)"> Tous les salariés de l'entreprise
            </label>
          </div>
          <div class="d-flex flex-column gap-2 form-group w-100 mt-3" *ngIf="!form.value.allInsureds">
            <label class="form-label required">Salarié(s)</label>
            <app-select [options]="insureds" *ngIf="insureds" formControlName="insureds" class="m outlined w-100"
              [multiple]="true"></app-select>
          </div>
        </ng-container>
      </ng-container>
      <!-- Mutuelle share : pick enterprises -->
      <div class="d-flex flex-column gap-2 form-group w-100 mt-3" *ngIf="user?.accessType === 'mutuelle'">
        <div class="info-message mt-2 mb-2">
          <i class="ti ti-info-hexagon"></i>
          Envoyez un message et des documents à une ou plusieurs entreprises.
        </div>
        <div class="d-flex flex-row gap-2">
          <label class="checkbox">
            <input class="me-2" type="checkbox" formControlName="allEnterprises"> Toutes les entreprises
          </label>
        </div>
        <div class="d-flex flex-column gap-2 mt-3" *ngIf="!form.value.allEnterprises">
          <label class="form-label required">Entreprise(s)</label>
          <app-select [options]="enterprises" *ngIf="enterprises" formControlName="enterprises" class="m outlined w-100"
            [multiple]="true"></app-select>
        </div>
      </div>
    </div>
    <div class="share-column-header d-flex align-items-center justify-content-center">
      <span class="label">Message</span>
    </div>
    <div class="share-column-content d-flex flex-column gap-3 w-100">
      <!-- Message -->
      <div class="d-flex flex-column gap-2 form-group w-100">
        <textarea formControlName="message" class="form-control" placeholder="Votre message..."></textarea>
      </div>
      <!-- Actions -->
      <div class="actions d-flex flex-row mt-auto gap-2">
        <button class="button m flex-grow-1" (click)="close()" type="button">Annuler</button>
        <button class="button m primary confirm flex-grow-1" (click)="createShare()" type="button">
          {{ sendButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</div>